import { JsonObject, JsonProperty } from 'json2typescript';
import { User } from '../users/user';
import { Message } from './message';


export enum ChatTypeEnum {
    PRIVATE = 1,
    FILE = 2,
    DEPARTMENT = 3
}

@JsonObject('Chat')
export class Chat {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('uuid', String, true)
    uuid: string = null;

    @JsonProperty('name', String, true)
    name: string = null;

    @JsonProperty('chat_type', Number, true)
    chatType: string = null;

    @JsonProperty('members_list', [User], true)
    membersList: User[] = [];

    @JsonProperty('last_message', Message, true)
    lastMessage: Message = null;

    @JsonProperty('created_date', String, true)
    createdDate: string = null;

    // write data
    @JsonProperty('members', [Number], true)
    members: number[] = [];

    get lastTimestamp() {
        return this.lastMessage ? this.lastMessage.createdDate : this.createdDate;
    }

    get lastMessageUser() {
        return this.lastMessage ? this.lastMessage.user.name : null;
    }

    get lastMessageContent() {
        return this.lastMessage ? this.lastMessage.content : null;
    }

    get membersStr() {
        return this.membersList.map(u => u.name).join(', ');
    }
}

